import { Campaign } from "@/models";
import { AnalyticsEvent } from "../models";
import { AnalyticsEventType } from "../platforms/adobe-analytics/models";

export class ExtraOptinEvent implements AnalyticsEvent {
    name = 'ExtraOptinEvent';

    constructor(public readonly eventType: AnalyticsEventType,
                public readonly activatedCampaign?: Campaign,
                public readonly isGroupCampaign?: boolean,
                public readonly cardInGroupIndex?: number) { }
}